module.exports = __webpack_public_path__ + "media/common/js/components/content-units/templates/innogy-introduction/i2-1-4af823c780842b2c912db0a9cfb81ddd.svg";